// Thin wrappers around the ElectricSheep compatibility Edge Functions that
// serve HireEva's ambassador surface. All ambassador reads/writes go through
// these — the React surface never touches the underlying tables directly.
import { supabase } from "@/integrations/supabase/shared";

export type AmbassadorDashboard = {
  ambassador?: {
    id: string;
    code: string;
    display_name: string;
    status: string;
    tier_cached?: number | null;
    invited_by_ambassador_id?: string | null;
  } | null;
  referral_code?: string | null;
  referral_url?: string | null;
  stats?: {
    clicks_total?: number;
    referrals_total?: number;
    referrals_active?: number;
    pending_cents?: number;
    approved_cents?: number;
    paid_cents?: number;
  } | null;
  rewards?: Array<{
    id?: string;
    label?: string;
    amount_cents?: number;
    status?: string;
    period_label?: string;
    occurred_at?: string;
  }>;
  // Pass-through bag so the dashboard can surface anything else the edge
  // function decides to return without a code change.
  [key: string]: unknown;
};

export async function getAmbassadorDashboard(): Promise<AmbassadorDashboard> {
  const { data, error } = await supabase.functions.invoke("get_ambassador_dashboard", {
    body: {},
  });
  if (error) throw error;
  return (data ?? {}) as AmbassadorDashboard;
}

export type EnsureAmbassadorInput = {
  desired_code?: string;
  display_name?: string;
  first_name?: string;
  last_name?: string;
  payout_email?: string;
  payout_method?: string;
  audience?: string;
  referred_by_code?: string | null;
};

export async function ensureAmbassadorAccount(
  input: EnsureAmbassadorInput = {},
): Promise<AmbassadorDashboard> {
  const { data, error } = await supabase.functions.invoke("ensure_ambassador_account", {
    body: input,
  });
  if (error) throw error;
  return (data ?? {}) as AmbassadorDashboard;
}

export type ResolveReferralResult = {
  ok?: boolean;
  code?: string;
  redirect_to?: string;
  ttl_ms?: number;
  ambassador?: { code?: string; display_name?: string } | null;
};

export async function resolveAmbassadorReferral(
  code: string,
  next?: string | null,
): Promise<ResolveReferralResult> {
  const { data, error } = await supabase.functions.invoke("resolve_ambassador_referral", {
    body: { code, next: next ?? null },
  });
  if (error) throw error;
  return (data ?? {}) as ResolveReferralResult;
}